// import { useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
// import { useAppDispatch } from "../../app/hook";
import CSDTable from "@cloudscape-design/components-themed/table";
import { DEFAULT_PAGE_SIZE } from "../../configs/constants";
import Preference from "../UI/Preference";
import Pagination from "../UI/Pagination";
import { getHeaderCounterText, getPagedItems } from "../../utils/common";
import {
  Header,
  Box,
  SpaceBetween,
  Container,
} from "@cloudscape-design/components-themed";
// import { showModal } from "../UI/modal/modal-slice";
import { LABELS } from "./constants";
import { COMMON_LABELS } from "../default-constants";
// import { useDeleteHoldingsContractMutation } from "../../features/api";
import {
  // HoldingsAffiliatedCompanyRegister,
  HoldingsAffiliatedCompany,
} from "../../features/api-interfaces";

export interface HoldingsUpdateAffiliatedStoreCompany {
  contractStatus: string;
  corporateNumber: string;
  companyName: string;
  contractService: string;
}

export interface HoldingsAffiliatedDeleteContract {
  contractStatus: string;
  corporateNumber: string;
  companyName: string;
  contractService: string;
}

const columnDefinitions = [
  {
    id: "contractStatusName",
    header: LABELS.STATUS,
    cell: (e: any) => e.contractStatusName,
  },
  {
    id: "corporateNumber",
    header: LABELS.CORPORATE_NUMBER,
    cell: (e: any) => e.corporateNumber,
  },
  {
    id: "companyName",
    header: LABELS.BUSINESS_NAME,
    cell: (e: any) => e.companyName,
  },
  {
    id: "contractService",
    header: LABELS.CONTRACT_SERVICE,
    cell: (e: any) =>
      e.contractService === "1"
        ? LABELS.SERVICE_NAME_BARCODE
        : e.contractService,
  },
];

/*
ホールディングス照会・更新画面(グループ傘下事業者情報)
 */
export const Table = (props: any) => {
  // const [deleteHoldingsContractMutation] = useDeleteHoldingsContractMutation();
  // const dispatch = useAppDispatch();

  // データをセット
  const holdingsAffiliatedStoreCompanyData: HoldingsAffiliatedCompany[] =
    props.holdingsAffiliatedStoreCompanyData;

  //ステータスコードに対応したステータスを取得
  const tableData = holdingsAffiliatedStoreCompanyData?.map((item) => ({
    ...item,
    contractStatusName: item.contractStatus,
  })) as HoldingsUpdateAffiliatedStoreCompany[];

  /**ページャ関連 */
  const options = columnDefinitions.map((column) => ({
    id: column.id,
    label: column.header,
  }));
  const [currentPageIndex, setCurrentPageIndex] = useState(1);
  const [preferences, setPreferences] = useState({
    pageSize: DEFAULT_PAGE_SIZE,
    visibleContent: options.map((o) => o.id),
  });

  const [pagedItems, setPagedItems] = useState<Object[]>([]);
  const [allItems, setAllItems] = useState<Object[]>([]);
  useEffect(() => {
    if (tableData !== undefined) {
      setPagedItems(getPagedItems(tableData, 1, DEFAULT_PAGE_SIZE));
      setAllItems(tableData);
      setCurrentPageIndex(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [holdingsAffiliatedStoreCompanyData]);

  /** 設定変更関数 */
  const handleOnConfirm = (detail: any) => {
    const newPageSize = detail.pageSize;
    setPreferences({
      pageSize: newPageSize,
      visibleContent: detail.visibleContent,
    });
    setPagedItems(tableData.slice(0, newPageSize));
    setCurrentPageIndex(1);
  };

  //削除対象チェックボックス用 *非表示
  // const [selectedItems, setSelectedItems] = useState<
  //   HoldingsAffiliatedDeleteContract[]
  // >([]);

  //事業者コード取得 *非表示
  // const { companyCode, name } = useParams();

  if (!holdingsAffiliatedStoreCompanyData) return null;

  // 削除ボタン押下　*非表示
  // const deleteOnClick = () => {
  //   if (selectedItems.length !== 0) {
  //     const isDeleteData = selectedItems?.map((value) => ({
  //       contractStatus: value.contractStatus,
  //       corporateNumber: value.corporateNumber,
  //       companyName: value.companyName,
  //       contractService: value.contractService,
  //     }));

  //     const data = {
  //       companyCode: companyCode as string,
  //       holdingsAffiliatedCompany: isDeleteData,
  //     };
  //     onClickDeleteBtnHandler(data);
  //   }
  // };

  /**
   * ダイアログ呼び出し *非表示
   */

  // const onClickDeleteBtnHandler = (data: HoldingsAffiliatedCompanyRegister) => {
  //   dispatch(
  //     showModal({
  //       title: COMMON_LABELS.TITLES.DL,
  //       content: COMMON_LABELS.TITLES.DELETE_CONFIRM,
  //       positiveFn: () => {
  //         deleteHoldingsContractMutation(data).then((result) => {
  //           setSelectedItems([]);
  //           props.refetchHoldingsAffiliatedStoreCompanyData();
  //         });
  //       },
  //     })
  //   );
  // };

  return (
    <Container header={<Header>{LABELS.MERCHANT_COMPANY_INFO}</Header>}>
      <CSDTable
        columnDefinitions={columnDefinitions}
        loading={props.isFetching}
        loadingText={COMMON_LABELS.CSD.LOADING_TEXT}
        items={pagedItems}
        resizableColumns
        stickyHeader
        trackBy="affiliatedStoreCompanyCode"
        header={
          <SpaceBetween size="xs">
            {/* 追加ボタンと削除ボタンの非表示 */}
            {/* <SpaceBetween direction="horizontal" size="l">
              <Button
                variant="normal"
                onClick={() => {
                  navigate(
                    "/holdings-contract-insert/" + companyCode + "/" + name
                  );
                }}
              >
                {COMMON_LABELS.BTNS.ADD}
              </Button>
              <Button variant="normal" onClick={deleteOnClick}>
                {COMMON_LABELS.BTNS.DELETE}
              </Button>
            </SpaceBetween> */}
            <Header>
              {LABELS.TITLE}
              {getHeaderCounterText(allItems.length, pagedItems.length)}
            </Header>
          </SpaceBetween>
        }
        pagination={
          <Pagination
            currentPageIndex={currentPageIndex}
            filteredItems={allItems}
            setCurrentPageIndex={setCurrentPageIndex}
            pageSize={preferences.pageSize}
            setPagedItems={setPagedItems}
          />
        }
        preferences={
          <Preference
            preferences={preferences}
            options={options}
            handleOnConfirm={handleOnConfirm}
          />
        }
        empty={
          <Box textAlign="center" color="inherit">
            {COMMON_LABELS.CSD.NO_DATA}
          </Box>
        }
      />
    </Container>
  );
};
